import { Reveal, SectionHeading } from "./Reveal";
import { EQUIPMENT, IMAGES } from "../../data/siteData";

export const Equipment = () => (
  <section id="equipment" className="section bg-[#081C3A]" data-testid="equipment-section">
    <div className="container-custom">
      <SectionHeading
        eyebrow="Equipment & Fleet"
        title="Resourced To Mobilise Anywhere"
        subtitle="A modern, well-maintained fleet and specialist equipment ready to deploy at speed across the country."
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {EQUIPMENT.map((item, i) => (
          <Reveal key={item.title} delay={(i % 4) * 0.08}>
            <div
              className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-[#00D4FF]/50 transition-all duration-300 h-72"
              data-testid={`equipment-card-${i}`}
            >
              <img
                src={IMAGES[item.image]}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050F22] via-[#050F22]/50 to-transparent" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <h3 className="text-lg font-bold text-white mb-1">{item.title}</h3>
                <p className="text-sm text-slate-300 leading-relaxed max-h-0 opacity-0 group-hover:max-h-32 group-hover:opacity-100 transition-all duration-500 overflow-hidden">
                  {item.text}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
